import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ColumnMode } from "@swimlane/ngx-datatable";
import { DownloadPdfRQ } from "app/open-api/model/downloadPdfRQ";
import { FilterSearchModel } from "./../../shared/models/filter-search.model";
import { DatePipe, CurrencyPipe } from '@angular/common';
import { take } from "rxjs/operators";
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import {
  AddAssigmentToDealerRQ,
  AssigmentModel,
  AssigmentService,
  DeleteBillFromFlightRQ,
  EditFlightAssigmentRQ,
  GetByFlightAssigmentIdRP,
  ListFlightAssigmentByAgencyRQ,
  RollbackRQ,
  BillService,
} from "app/open-api";
import { EditFlightAssigmentModalComponent } from "app/shared/components/edit-flight-assigment-modal/edit-flight-assigment-modal.component";
import { NgxSpinnerService } from "ngx-spinner";
import Swal from "sweetalert2";
import { environment } from "./../../../environments/environment";
import { AssignBillDealerModalComponent } from "./../../shared/components/assign-bill-dealer-modal/assign-bill-dealer-modal.component";
import { AssigmentLocalModel, AssigmentListModelToExport } from "app/shared/models/assigment-local.model";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { FilterService } from "./../../shared/services/filter.service";
import { Observable  } from "rxjs";
import {FilterSearchObj, FilterChip} from "./../../shared/models/filter-search.model";
import { MultipleFiltersComponent } from "app/shared/components/multiple-filters/multiple-filters.component";
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import { ShippingType, shippingTypes } from '../../open-api/model/shippingType';
import {catalogStates, CatalogBillState } from "./../../shared/models/catalogBillState";
import * as XLSX from 'xlsx';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: "app-assiggnment-to-flight",
  templateUrl: "./assiggnment-to-flight.component.html",
  styleUrls: ["./assiggnment-to-flight.component.scss"],
  providers: [DatePipe, CurrencyPipe],
})
export class AssiggnmentToFlightComponent implements OnInit {
  @ViewChild("popOver") public popover: NgbPopover;
  @ViewChild('searchInput') searchInput: ElementRef;
  public basicSelectedOption: number = 5;
  public bills: AssigmentLocalModel[] = [];
  public allBills: AssigmentLocalModel[] = [];
  public filterChips: FilterChip[] = [];
  public ColumnMode = ColumnMode;
  shippingTypes: Array<ShippingType> = [];
  catalogStates: Array<CatalogBillState> = []
  urlApi = environment.apiUrl;
  loadedFilter$: Observable<any>;
  //currentfilter: FilterSearchObj;
  fatherComponent: string = "flight";
  currentfilter: FilterSearchModel;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];  
  @ViewChild("TABLE") table: ElementRef;

  constructor(
    private assigmentService: AssigmentService,
    private billService: BillService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private filterService: FilterService,
    private datePipe: DatePipe,
    private currencyPipe: CurrencyPipe
  ) {
    this.shippingTypes = shippingTypes;
    this.catalogStates = catalogStates;
    this.loadedFilter$ = filterService.getFilterObservable;
  }

  ngOnInit(): void {
    this.FetchModels();
  }

  openPopover() {
    this.popover.open();
  }

  Remove(chip: FilterChip): void {
    
    const index = this.filterChips.indexOf(chip);

    if (index >= 0) {
      this.filterChips.splice(index, 1);
    }

    this.ResetFilter(chip.name);
  }

  async ResetFilter(value: string){
    if(value == "Provincia:")
      this.currentfilter.provincia = null;
    if(value == "Municipio:")
      this.currentfilter.municipio = null;
    if(value == "Desde:")
      this.currentfilter.desde = null;
    if(value == "Hasta:")
      this.currentfilter.hasta = null;
    if(value == "Envío:")
      this.currentfilter.envios = null;
    if(value == "Vuelo:")
      this.currentfilter.vuelos = null;
    if(value == "Teléfono:")
      this.currentfilter.telefono = null;
    if(value == "Tipo envío:")
      this.currentfilter.tipoEnvio = null;
    if(value == "Estado:")
      this.currentfilter.state = null;

    const data = await this.loadedFilter$.pipe(take(1)).toPromise();
    if (data !== undefined) {
      let filter: FilterSearchObj = data;

      if(this.currentfilter.provincia == null)
        filter.provincia = null;

      if(this.currentfilter.municipio == null)
        filter.municipio = null;

      if(this.currentfilter.desde == null)
        filter.desde = null;

      if(this.currentfilter.envios == null)
        filter.envios = null;

      if(this.currentfilter.state == null)
        filter.state = null;

      if(this.currentfilter.vuelos == null)
        filter.vuelos = null;

      if(this.currentfilter.telefono == null)
        filter.telefono = null;

      if(this.currentfilter.tipoEnvio == null)
        filter.tipoEnvio = null;
      
      this.filterService.setFilterObservable = filter;
    }
         
    this.spinner.show();
    //this.filterChips = this.CreateFilterChips(this.currentfilter);
    /*this.loadedFilter$.subscribe((res) => {
      if(res != undefined)
        this.filterChips = this.CreateFilterChips(res);
    });*/

    this.assigmentService.apiAssigmentListFlightsByParams(this.currentfilter).subscribe(
      (response) => {
        
        this.bills = this.ModelParse(response.list);
        this.allBills = this.bills;
        this.spinner.hide();
      },
      (error) => {
        Swal.fire({
          title: "Error! " + error,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
        });
        this.spinner.hide();
      }
    );
  }

  RefreshBills(){
    this.ResetSearch();
    if(this.FilterHasValues()){
      this.FetchByFilter();
    }else {
      this.FetchModels();
    }
  }

  totalPounds(){    
    if(this.bills.length > 0){
      let sum = this.bills.reduce((accumulator, item) => {
        return accumulator + Number(Number(item.billPounds).toFixed(2));
      },0);   
      return sum; 
    }
    return 0;    
  }

  export(){
    const swal = Swal.fire({
      title: "Escoja la opción de exportar datos.",      
      icon: "warning",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: "Excel",
      cancelButtonText: "PDF",
      customClass: {
        confirmButton: "btn btn-primary",
        cancelButton: "btn btn-danger",
      },
    }).then((result) => {
      //console.log(result)
      if (result.isConfirmed) {
        this.exportexcel();
      }
      else if (result.isDismissed && result.dismiss == Swal.DismissReason.cancel){
        this.generatePDF();
      }
    })
  }

  totalPaid(){
    let sum = this.bills.reduce((accumulator, item) => {
      return accumulator + Number(item.billTotal.toFixed(2));
    },0);   
    return sum; 
  }

  generatePDF() {
    this.spinner.show();
    const contenido: string[][] = [];
    contenido.push([
      "#",
      "CODIGO",
      "ORIGEN",
      "DESTINO",
      "PESO",
      "TOTAL",
      "VUELO",
      "ESTADO",
    ]);
    
    this.bills.forEach((b, index) => {      
      contenido.push([
        (index + 1).toString(),
        b.billCode + " " + (b.serviceCode ?? ''),
        b.billSenderModel.Name,
        b.billCustomerModel.Name,
        b.billPounds.toString(),
        this.currencyPipe.transform(b.billTotal),
        b.flightCode,
        //this.datePipe.transform(b.shippingCreateAt, "MMM/dd/yyyy"),
        
        b.billStateCatalogName,
      ]);
    });
    const totalColumn: any[] = [];

    const documentDefinition = {
      pageOrientation: "landscape",
      pageSize: "LETTER",
      content: [
        {
          columns: [
            { text: "Reporte Facturas asignadas a vuelo: ", style: ["title"], margin: [0, 10] },
          ],
        },
        {
          text: "Fecha: " + this.datePipe.transform(new Date(), "MMM/dd/yyyy"),
          style: ["subtitle"],
          margin: [0, 0],
        },
        {
          layout: "lightHorizontalLines",
          table: {
            headerRows: 1,
            widths: ["auto", "auto", "auto", "auto", "auto", "auto", "auto", "auto"],
            body: contenido,
          },
        },
      ],
      styles: {
        title: {
          fontSize: 22,
          bold: true,
          alignment: "left",
        },
        title2: {
          fontSize: 12,
          bold: true,
          alignment: "right",
        },
        subtitle: {
          fontSize: 14,
          alignment: "left",
        },
        footer: {
          fontSize: 8,
          alignment: "right",
        },
      },
    };
    pdfMake.createPdf(documentDefinition).open();
    this.spinner.hide();
  }

  exportList(): AssigmentListModelToExport[]{
    let exportflights: AssigmentListModelToExport[] = [];
    if (this.bills)
      this.bills.forEach((row) => {
        let now: AssigmentListModelToExport = this.GetAssigmentToExport(row);
        exportflights.push(now);
      });  
      return exportflights;  
  }

  GetAssigmentToExport(row: AssigmentLocalModel) {   

    let ret: AssigmentListModelToExport = {
      CODIGO: row.billCode,
      ORIGEN: row.billSenderModel.Name,
      DESTINO: row.billCustomerModel.Name,
      PESO: row.billPounds,
      TOTAL: row.billTotal.toString(),
      VUELO: row.flightCode,
      ESTADO: row.billStateCatalogName              
    };
    return ret;
  }


  exportexcel(): void
  {
    /* pass here the data source */
    let exportobj: any = this.exportList();
    //console.log(exportobj)
    const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet(exportobj);
 
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    let newDate:  Date = new Date();
    const fecha = this.datePipe.transform(newDate, "MMM/dd/yyyy");
    
    let fileName: any = `facturasasignadasavuelo_${fecha}.xlsx`;
 
    /* save to file */  
    XLSX.writeFile(wb, fileName);
 
  }

  FetchModels() {
    this.spinner.show();
    const param: ListFlightAssigmentByAgencyRQ = {
      agencyId: null,
    };
    this.assigmentService.apiAssigmentListFlightsByAgencyPost(param).subscribe(
      (response) => {
        this.bills = this.ModelParse(response.list);
        this.allBills = this.bills;
        this.spinner.hide();
      },
      (error) => {
        Swal.fire({
          title: "Error! " + error,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
        });
        this.spinner.hide();
      }
    );
  }

  pipe = new DatePipe('en-US');

  CreateFilterChips(filtro: FilterSearchModel){
    let listChips: FilterChip[] = [];
    
    if (filtro.provincia != "" && filtro.provincia != null) {
      let filterChip: FilterChip = {
        name: "Provincia:",
        text: filtro.provincia,
      };
      listChips.push(filterChip);
    }

    if (filtro.municipio != "" && filtro.municipio != null) {
      let filterChip: FilterChip = {
        name: "Municipio:",
        text: filtro.municipio,
      };
      listChips.push(filterChip);
    }

    if (filtro.desde != null) {
      const myFormattedDate = this.pipe.transform(filtro.desde, 'longDate');

      let filterChip: FilterChip = {
        name: "Desde:",
        text: myFormattedDate,
      };
      listChips.push(filterChip);
    }

    if (filtro.hasta != null) {
      const myFormattedDate = this.pipe.transform(filtro.hasta, 'longDate');

      let filterChip: FilterChip = {
        name: "Hasta:",
        text: myFormattedDate,
      };
      listChips.push(filterChip);
    }

    if (filtro.telefono != "" && filtro.telefono != "null") {
      let filterChip: FilterChip = {
        name: "Teléfono:",
        text: filtro.telefono,
      };
      listChips.push(filterChip);
    }    

    if (filtro.state != "" && filtro.state != "null") {
      let filterChip: FilterChip = {
        name: "Estado:",
        text: this.catalogStates.find(item => item.id == +filtro.state).name,
      };
      listChips.push(filterChip);
    }    
    
    if (filtro.tipoEnvio != "" && filtro.tipoEnvio != null) {    

      const tipo = this.shippingTypes
        .find((i) => i.id === +filtro.tipoEnvio)
        .name.toString();

      let filterChip: FilterChip = {
        name: "Tipo envío:",
        text: tipo,
      };
      listChips.push(filterChip);
    }

    if (filtro.envios != "" && filtro.envios != null) {
      let filterChip: FilterChip = {
        name: "Envío:",
        text: filtro.envios,
      };
      listChips.push(filterChip);
    }

    if (filtro.vuelos != "" && filtro.vuelos != null) {
      let filterChip: FilterChip = {
        name: "Vuelo:",
        text: filtro.vuelos,
      };
      listChips.push(filterChip);
    }

    return listChips;
  }

  SetFilter(prueba: any) {
    console.log(prueba)
    let filtro: FilterSearchModel = prueba;
    this.currentfilter = filtro;
    this.closePopover();
    this.spinner.show();    
    this.filterChips = this.CreateFilterChips(filtro);
   
    this.assigmentService.apiAssigmentListFlightsByParams(filtro).subscribe(
      (response) => {
        
        this.bills = this.ModelParse(response.list);
        this.allBills = this.bills;
        this.spinner.hide();
      },
      (error) => {
        Swal.fire({
          title: "Error! " + error,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
        });
        this.spinner.hide();
      }
    );
  }

  FetchByFilter(){
    //let filtro: FilterSearchModel = prueba;
    //this.currentfilter = filtro;
    //this.closePopover();
    this.spinner.show();
    //this.filterChips = this.CreateFilterChips(this.currentfilter);
    /*this.loadedFilter$.subscribe((res) => {
      if(res != undefined)
        this.filterChips = this.CreateFilterChips(res);
    });*/
    if(this.currentfilter == undefined)
    {
      this.currentfilter = {
        desde: null,
        envios: null,
        hasta: null,
        municipio: null,
        provincia: null,
        state: null,
        telefono: null,
        tipoEnvio: null,
        vuelos: null
      }      
    }    
    this.assigmentService.apiAssigmentListFlightsByParams(this.currentfilter).subscribe(
      (response) => {        
        this.bills = this.ModelParse(response.list);
        this.allBills = this.bills;
        this.spinner.hide();
      },
      (error) => {
        Swal.fire({
          title: "Error! " + error,
          icon: "error",
          showConfirmButton: false,
          timer: 2000,
          position: "top-end",
        });
        this.spinner.hide();
      }
    );
  }

  public closePopover(): void {
    //this.maskEditorAppliedMessage = null;
    if (this.popover.isOpen()) this.popover.close();
  }

  ModelParse(array: AssigmentModel[]): AssigmentLocalModel[] {
    return array.map(({ billCustomerModel, billSenderModel, ...rest }) => ({
      ...rest,
      billCustomerModel: JSON.parse(billCustomerModel),
      billSenderModel: JSON.parse(billSenderModel),
    }));
  }

  FilterReset(result: boolean) {
    if (result) {
      this.FetchModels();
      this.filterChips = [];
      this.currentfilter = null;
    }
  }

  ResetSearch() {    
    this.searchInput.nativeElement.value = '';
  }

  FilterUpdate(event) {
    if (event && event !== "") {
      this.bills = this.allBills.filter(
        (x) => ((x.billCode?.toLowerCase().indexOf(event.toLowerCase()) > -1) || (x.serviceCode?.toLowerCase().indexOf(event.toLowerCase()) > -1))
      );
    } else {
      this.bills = this.allBills;
    }
  }

  EditFlightAssigment(assigmentId: number) {
    const refModal = this.modalService.open(EditFlightAssigmentModalComponent, {
      windowClass: "modal",
      size: "sm",
    });
    refModal.componentInstance.assigmentId = assigmentId;

    refModal.result.then((result: GetByFlightAssigmentIdRP) => {
      if (result) {
        const params: EditFlightAssigmentRQ = {
          assigmentId: result.assigmentId,
          flightId: result.flightId,
        };
        this.assigmentService
          .apiAssigmentEditFlitghAssigmentPost(params)
          .subscribe(
            () => {
              Swal.fire({
                title: "Asignación Actualizada.",
                icon: "success",
                showConfirmButton: false,
                timer: 2000,
                position: "top-end",
              });
              this.FetchByFilter();
            },
            (error) => {             
              Swal.fire({
                title: "Error! " + error,
                icon: "error",
                showConfirmButton: false,
                timer: 2000,
                position: "top-end",
              });
            }
          );
      }
    });
  }

  DownloadPdf(billId: number) {
    this.spinner.show();
    const param: DownloadPdfRQ = {
      billId: billId,
    };

    this.billService.apiDownloadPdfPost(param).subscribe(
      (response) => {
        //console.log();
        const fileURL = URL.createObjectURL(response);
        window.open(fileURL, "_blank");

        Swal.fire({
          title: `El pdf se descargó satisfactoriamente.`,
          icon: "success",
          showConfirmButton: false,
          timer: 5000,
          position: "top",
        });

        this.spinner.hide();
      },
      (error) => {
        //console.warn(error);
        Swal.fire({
          title: "Error! " + error.error,
          icon: "error",
          showConfirmButton: false,
          timer: 5000,
          position: "top",
        });
        this.spinner.hide();
      }
    );
  }

  Unassign(assigmentId: number) {
    const swal = Swal.fire({
      title: "¿Está seguro que desea desasignar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Desasignar",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-primary",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const param: RollbackRQ = {
          assigmentId,
        };
        this.assigmentService.apiAssigmentRollbackPost(param).subscribe(
          (response) => {
            Swal.fire({
              title: "Se desasignó correctamente.",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
            });
            this.FetchByFilter();
            //this.FetchModels();
          },
          (error) => {
            Swal.fire({
              title: "Error! " + error,
              icon: "error",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
            });
            this.spinner.hide();
          }
        );
      }
    });
  }

  FilterHasValues(){
    if(this.currentfilter != null){      
      return (this.currentfilter.desde != null) || (this.currentfilter.hasta != null) || (this.currentfilter.envios != null && this.currentfilter.envios != "")  || (this.currentfilter.vuelos != null && this.currentfilter.vuelos != "") || (this.currentfilter.provincia != null && this.currentfilter.provincia != "") || (this.currentfilter.municipio != null && this.currentfilter.municipio != "") || (this.currentfilter.telefono != "")
    }
    return false;
    
  }

  AssignToDealer(assigmentId: number) {
    const refModal = this.modalService.open(AssignBillDealerModalComponent, {
      windowClass: "modal",
      size: "lg",
    });    
    refModal.componentInstance.bill = this.allBills.filter(
      (x) => x.id === assigmentId
    )[0];
    refModal.result.then((result) => {
      if (result) {
        const model: AddAssigmentToDealerRQ = result.bill;
        const assign = this.bills.find((bill) => bill.id == assigmentId);
        model.billsId = [assign.billId];
        this.assigmentService.apiAssigmentAddToDealerPost(model).subscribe(
          (response) => {
            Swal.fire({
              title: "Asignada correctamente.",
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
            });
            if(this.FilterHasValues())
              this.FetchByFilter();            
            else this.FetchModels();
          },
          (error) => {
            Swal.fire({
              title: "Error! " + error,
              icon: "error",
              showConfirmButton: false,
              timer: 2000,
              position: "top-end",
            });
          }
        );
      }
    });
  }

  ShowButtonAssign(assigmentId: number): boolean {
    const assign = this.allBills.find((bill) => bill.id == assigmentId);
    return assign.billStateCatalogName !== "ASIG. VUELO";
  }

  DeleteBill(assigmentId: number) {
    const swal = Swal.fire({
      title: "¿Está seguro que desea Eliminar permanentemente la factura?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
      customClass: {
        confirmButton: "btn btn-danger",
        cancelButton: "btn btn-primary",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const param: DeleteBillFromFlightRQ = {
          assigmentId,
        };
        this.assigmentService
          .apiAssigmentDeleteBillFromFlightPost(param)
          .subscribe(
            (response) => {
              Swal.fire({
                title: "Se eliminó correctamente.",
                icon: "success",
                showConfirmButton: false,
                timer: 2000,
                position: "top-end",
              });
              if(this.FilterHasValues())
                this.FetchByFilter();            
              else this.FetchModels();
            },
            (error) => {
              Swal.fire({
                title: "Error! " + error,
                icon: "error",
                showConfirmButton: false,
                timer: 2000,
                position: "top-end",
              });
              this.spinner.hide();
            }
          );
      }
    });
  }

  GetURLById(id: number) {
    const bill = this.bills.find((b) => b.id === id);
    return this.urlApi + "/Bills/" + bill.billFile;
  }

  GetCodeById(id: number) {
    const bill = this.bills.find((b) => b.billId === id);
    return bill.billCode;
  }

  GetServiceCodeById(id: number) {    
    const bill = this.bills.find(b => b.billId === id);
    return bill.serviceCode;
  }
}
